<template>
  <li class="cube-index-list-group">
    <div class="cube-index-list-anchor" v-html="group.name"></div>
    <ul>
      <slot>
        <cube-index-list-item
          v-for="(item, index) in group.items"
          :key="index"
          :item="item"
          @select="selectItem"
        ></cube-index-list-item>
      </slot>
    </ul>
  </li>
</template>

<script>
import CubeIndexListItem from './index-list-item.vue'

const COMPONENT_NAME = 'cube-index-list-group'
const EVENT_SELECT = 'select'

export default {
  name: COMPONENT_NAME,
  props: {
    group: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  methods: {
    selectItem(item) {
      this.$emit(EVENT_SELECT, item)
    }
  },
  components: {
    CubeIndexListItem
  }
}
</script>

<style lang="scss" scoped>
.cube-index-list-anchor {
  padding: 16px 16px 10px 16px;
  line-height: 1;
  font-size: 14px;
  color: #999999;
  background: #f7f7f7;
}
</style>
